<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Base Picker</h3>
              <div>currently available: Stamen Basemaps (more to be wired-up)</div>
            </div>
          </v-card-title>
            <v-btn
            v-for="option in options"
            :key="option"
            flat
            color="orange"
            @click.native="basePicker(option)">
            >
            {{ option }}
            </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    options () {
      return this.$store.getters.stamenBaseOptions
    }
  },
  methods: {
    basePicker (payload) {
      this.$store.dispatch('pickBase', payload)
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolBox/basepicker.vue